/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createDeprecatedTypeof } from '../../factoriesAny.js';
export var typeofDependencies = {
  createDeprecatedTypeof: createDeprecatedTypeof
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDeprecatedTypeof.generated.js
// module id = 1524
// module chunks = 0